interface RawNetworkPanelPageNavProps {
  totalPageCount: number;
  activeTab: number;
  maxButtonsVisible: number;
  setActiveTab: (tabIndex: number) => void;
}
const RawNetworkPanelPageNav = ({
  totalPageCount,
  activeTab,
  maxButtonsVisible,
  setActiveTab,
}: RawNetworkPanelPageNavProps) => {
  const navButtons = [];
  let startPageIndex = 0;
  let endPageIndex = totalPageCount;

  if (totalPageCount > maxButtonsVisible) {
    if (activeTab <= 2) {
      startPageIndex = 0;
      endPageIndex = maxButtonsVisible;
    } else if (activeTab >= totalPageCount - 3) {
      startPageIndex = totalPageCount - maxButtonsVisible;
      endPageIndex = totalPageCount;
    } else {
      startPageIndex = activeTab - 2;
      endPageIndex = activeTab + 3;
    }
  }
  if (startPageIndex > 0) {
    navButtons.push(
      <button
        key="prev"
        className="btn btn-sm mx-1 btn-secondary"
        onClick={() => setActiveTab(startPageIndex - 1)}
      >
        &lt;
      </button>,
    );
  }
  for (let i = startPageIndex; i < endPageIndex; i++) {
    navButtons.push(
      <button
        key={i}
        className={`btn btn-sm mx-1 ${activeTab === i ? "btn-primary" : "btn-secondary"}`}
        onClick={() => setActiveTab(i)}
        style={{ minWidth: 36 }}
      >
        {i + 1}
      </button>,
    );
  }
  if (endPageIndex < totalPageCount) {
    navButtons.push(
      <button
        key="next"
        className="btn btn-sm mx-1 btn-secondary"
        onClick={() => setActiveTab(endPageIndex)}
      >
        &gt;
      </button>,
    );
  }
  return <div className="d-flex justify-content-center mb-3">{navButtons}</div>;
};

export default RawNetworkPanelPageNav;
